import React, { useState } from 'react'
import { useContextHook } from 'use-context-hook'
import { StyledOnboardingHeader } from './NewOnboarding.styles'
import lgLogo from '../../../assets/nav/new-logo-lg-2.svg';
import Button from '../../molecules/Button';
import { AuthContext } from '../../../Context/authContext';
import onboardingService from '../../../services/onboardingService';
import { clearProgress } from './onboardingProgress';

const OnboardingHeader = () => {
  const { onLogout } = useContextHook(AuthContext, v => ({ onLogout: v.onLogout }));
  const [skipping, setSkipping] = useState(false);

  const handleSkip = async () => {
    setSkipping(true);
    // clearProgress();
    window.location.assign('/dashboard');
  };

  return (
    <StyledOnboardingHeader>
      <div className="logo-holder">
        <img src={lgLogo} alt='logo' />
      </div>
      <div className='btn-holder'>
        <Button variant="dark" width="120px" rounded onClick={handleSkip} disabled={skipping}>
          {skipping ? 'Skipping…' : 'Skip Now'}
        </Button>
        <Button variant="outline" width="120px" rounded onClick={onLogout}>Logout</Button>
      </div>
    </StyledOnboardingHeader>
  )
}

export default OnboardingHeader
